export type SiteConfig = typeof siteConfig;

export const siteConfig = {
    name: "TanRabad Report",
    desc: "ทันระบาด รายงาน",
    pageItems: [
        {
            title: "จำนวนผู้ป่วย",
            key: "case",
            org_type: ["01"]
        },
        {
            title: "ผลสำรวจลูกน้ำยุงลาย",
            key: "larval",
            org_type: ["01", "02", "03", "06"]
        },
        {
            title: "ผลสำรวจภาชนะขังน้ำ",
            key: "container",
            org_type: ["01", "02", "03", "06"]
        },
        {
            title: "ผลการปฏิบัติงาน",
            key: "execution",
            org_type: ["01", "02", "03", "06"]
        },
    ],
};
